import React from 'react';
import ContentLoader from 'react-content-loader';
import classNames from 'classnames';

import './RawDataTable.scss';

const BasicFormItem = ({ className }) => {
  const classes = classNames(className, 'lanl-form-group');
  return (
    <ContentLoader
      speed={2}
      width={555}
      height={120}
      viewBox='0 0 555 120'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
      className={classes}
      style={{ minWidth: '215px' }}
    >
      <rect x='0' y='0' rx='0' ry='0' width='175' height='28' />
      <rect x='0' y='48' rx='0' ry='0' width='555' height='50' />
    </ContentLoader>
  );
};

export const Skeleton = () => {
  return (
    <div className='wm-raw-data-table'>
      <div className='raw-data-form'>
        <BasicFormItem className='half-width' />
        <BasicFormItem className='half-width' />
        <BasicFormItem className='half-width' />
        <BasicFormItem className='half-width' />
        <BasicFormItem />
        <div className='full-width lanl-form-group'>
          <ContentLoader
            speed={2}
            width={555}
            height={120}
            viewBox='0 0 555 120'
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
          >
            <rect x='0' y='0' rx='0' ry='0' width='255' height='50' />
          </ContentLoader>
        </div>
      </div>
    </div>
  );
};
